<script lang="ts">
	import DecisionTree from './components/DecisionTree.svelte';
</script>

<div class="min-h-screen bg-gradient-to-br from-base-200 via-base-300 to-base-200">
	<div class="container mx-auto px-4 py-8 md:py-12">
		<div class="max-w-5xl mx-auto">
			<div class="card bg-base-100 shadow-2xl backdrop-blur-sm">
				<div class="card-body p-6 md:p-10">
					<DecisionTree />
				</div>
			</div>
		</div>
	</div>
</div>